import { Box, Flex, Image, Text } from '@chakra-ui/react';
import { MdDoubleArrow } from 'react-icons/md';

const PressButton = ({ className, image, onDown, onUp }) => (
  <Box
    className={className}
    onPointerDown={(e) => { e.preventDefault(); e.currentTarget.setPointerCapture?.(e.pointerId); onDown(); }}
    onPointerUp={(e) => { e.preventDefault(); onUp(); }}
    onPointerCancel={onUp}
    onPointerLeave={onUp}
  >
    <Image pointerEvents="none" userSelect="none" alt="" draggable="false" src={image} />
  </Box>
);

const Controls = ({
  pedals,
  setIsMovingLeft,
  setIsMovingRight,
  isAccelerating,
  setIsAccelerating,
  pedalsIsAuto,
  category,
  GarageIsOpen,
}) => {
  const hidden = GarageIsOpen && (category === 0 || category === 1);

  if (!pedalsIsAuto) {
    return (
      <Flex className="race-controls race-controls-manual" display={hidden ? 'none' : 'flex'}>
        <Flex className="race-steering-cluster">
          <PressButton className="race-control-btn" image={pedals?.model?.l} onDown={() => setIsMovingLeft(true)} onUp={() => setIsMovingLeft(false)} />
          <PressButton className="race-control-btn" image={pedals?.model?.r} onDown={() => setIsMovingRight(true)} onUp={() => setIsMovingRight(false)} />
        </Flex>
        <PressButton className="race-gas-btn" image={pedals?.model?.g} onDown={() => setIsAccelerating(true)} onUp={() => setIsAccelerating(false)} />
      </Flex>
    );
  }

  return (
    <>
      <Flex className="race-auto-steering" display={hidden ? 'none' : 'flex'}>
        <PressButton className="race-control-btn race-auto-btn" image={pedals?.model?.l} onDown={() => setIsMovingLeft(true)} onUp={() => setIsMovingLeft(false)} />
        <PressButton className="race-control-btn race-auto-btn" image={pedals?.model?.r} onDown={() => setIsMovingRight(true)} onUp={() => setIsMovingRight(false)} />
      </Flex>

      <Box className="race-start-toggle" display={hidden ? 'none' : 'block'} onClick={() => setIsAccelerating(!isAccelerating)}>
        {!isAccelerating && (
          <Box className="race-start-chevrons" transform="rotate(-90deg)">
            <MdDoubleArrow style={{marginLeft: '40px'}} />
          </Box>
        )}
        <Text className={isAccelerating ? 'is-running' : ''}>{isAccelerating ? 'STOP' : 'START'}</Text>
      </Box>
    </>
  );
};

export default Controls;
